// extracted by mini-css-extract-plugin
export default {"item":"SeriesList_item__5ny-U","completed":"SeriesList_completed__0RdCJ"};